export default {
  nav: {
    home: 'Strona główna',
    categories: 'Kategorie',
    shoppingGuide: 'Przewodnik zakupowy',
    explore: 'Odkryj arkusz',
  },
  hero: {
    badge: 'Niezależny serwis informacyjny',
    title: 'USFans Spreadsheet — przewodnik, lista twórców i najważniejsze informacje',
    subtitle:
      'Uporządkowane źródło informacji, przewodników, porównań i materiałów o twórcach, wysyłce, kuponach i bezpieczeństwie — wszystko w jednym miejscu.',
    ctaSpreadsheet: 'USFans Spreadsheet',
    ctaBuy: 'Kup teraz',
    mockupTitle: 'Arkusz twórców',
    mockupSearch: 'Szukaj twórców...',
    mockupColCategory: 'Kategoria',
    mockupColName: 'Nazwa',
    mockupColStatus: 'Status',
    mockupStatusActive: 'Aktywny',
    mockupStatusNew: 'Nowy',
    mockupNote: 'Posortowane według kategorii · z filtrowaniem',
  },
  trust: {
    title: 'Dlaczego warto korzystać z USFans Spreadsheet?',
    item1Title: 'Aktualizowane informacje',
    item1Desc: 'Utrzymujemy przewodniki, porównania i zasoby aktualne i trafne.',
    item2Title: 'Przejrzyste informacje',
    item2Desc: 'Porządkujemy materiały w łatwe do przeglądania kategorie.',
    item3Title: 'Bezpieczeństwo przede wszystkim',
    item3Desc: 'Nie udostępniaj haseł, kodów weryfikacyjnych ani poufnych danych.',
    item4Title: 'Niezależny przewodnik',
    item4Desc: 'Serwis ma charakter informacyjny — nie jest oficjalną stroną USFans.',
  },
  categories: {
    title: 'Przeglądaj według kategorii',
    subtitle: 'Wybierz kategorię poniżej, aby zobaczyć pełną kolekcję w naszym głównym sklepie.',
    dropdownLabel: 'Wybierz kategorię',
    dropdownHint: 'Wybierz kategorię, aby ją otworzyć',
    items: {
      shoes: 'Buty',
      hoodies: 'Bluzy i swetry',
      tshirts: 'Koszulki',
      jackets: 'Kurtki',
      pants: 'Spodnie i szorty',
      headwear: 'Czapki',
      sets: 'Zestawy',
      underwear: 'Bielizna',
      jersey: 'Koszulki sportowe',
      accessories: 'Akcesoria',
      bags: 'Torby',
      belts: 'Paski',
      perfumes: 'Perfumy',
      other: 'Inne',
    },
  },
  about: {
    title: 'Czym jest USFans Spreadsheet?',
    lead:
      'USFans Spreadsheet to uporządkowany sposób przeglądania i organizowania informacji o twórcach, zasobach i przewodnikach związanych z platformą USFans.',
    p1: 'Naszym celem jest ułatwienie znalezienia potrzebnych informacji bez przeszukiwania wielu różnych stron. Dzięki przejrzystemu układowi możesz szybciej porównać twórców, sprawdzić kategorie i przejść do właściwego źródła.',
    p2: 'Arkusze sprawdzają się szczególnie dobrze dla początkujących, którzy chcą najpierw uzyskać ogólny obraz, zanim zagłębią się w konkretnych twórców lub zasoby.',
    listTitle: 'Najważniejsze korzyści:',
    list: [
      'Uporządkowane informacje w jednym miejscu',
      'Szybsze wyszukiwanie i filtrowanie',
      'Przewodniki dla początkujących',
      'Porównania różnych opcji obok siebie',
      'Zaktualizowane informacje o bezpieczeństwie',
      'Odświeżalna, udostępnialna struktura',
    ],
  },
  articleCta: {
    title: 'Przeczytaj pełny przewodnik USFans Spreadsheet',
    subtitle:
      'Dowiedz się więcej o listach twórców, katalogach, porównaniach i wskazówkach dotyczących bezpieczeństwa.',
    button: 'Otwórz przewodnik',
  },
  articles: {
    title: 'Przewodniki i zasoby USFans',
    subtitle: 'Szczegółowe przewodniki o recenzjach, wysyłce, kuponach, magazynie, bezpieczeństwie i nie tylko.',
    readMore: 'Czytaj przewodnik',
  },
  footer: {
    disclaimer:
      'USFansLink to niezależny serwis informacyjny i nie jest powiązany z USFans ani przez niego prowadzony.',
    rights: 'Wszelkie prawa zastrzeżone.',
    backHome: 'Strona główna',
    mainSite: 'Odwiedź główny sklep',
  },
};